import { Component, Host, h, Prop } from '@stencil/core';
import { CARDS } from './assets'

@Component({
  tag: 'snap-card-image',
  styleUrl: 'snap-card-image.scss',
  shadow: true
})
export class SnapCardImage {
  @Prop() productCard: boolean = false;
  @Prop() image: string
  @Prop() cardType: string  =  'snap-spend-card'

  private renderSnapCreditCard() {
    return (
      <div class='snap-card-product' innerHTML={CARDS[this.cardType]}>
      </div>
    )
  }
  render() {
    return (
      <Host>
        {this.productCard && !this.image ?
          this.renderSnapCreditCard()
        : null
        }
        {this.image && !this.productCard ?
          <div class="snap-card-image">
            <snap-avatar image-src={this.image} shape='rounded'/>
          </div>
        : null
        }
      </Host>
    );
  }

}
